<div class="table-body tab-content-1">
  <div class="row">
    <div class="col-12 col-lg-12 mt-3" *ngIf="listProspectus?.length">
      <div class="row table-row table-heading">
        <div class="col-8 tt-buy-hgt">
          <label class="title-fee">{{'Bản cáo bạch' | translate}}</label>
          <br />
        </div>
        <div class="col-4 col-sm-4 tt-buy-hgt"></div>
      </div>
      <div class="row row-color" *ngFor="let item of listProspectus">
        <div class="col-8 tt-buy-hgt no-padding-right">
          <a [href]="item.url" target="_blank">{{item.fileName}}</a>
        </div>
        <div class="col-4 tt-buy-hgt text-right">
          <label class="label-name text-left">{{item.applyAt}}</label>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-12 mt-3" *ngIf="listSummaryProspectus?.length">
      <div class="row table-row table-heading">
        <div class="col-8 tt-buy-hgt">
          <label class="title-fee">{{'Bản cáo bạch tóm tắt' | translate}}</label>
          <br />
        </div>
        <div class="col-4 col-sm-4 tt-buy-hgt"></div>
      </div>
      <div class="row row-color" *ngFor="let item of listSummaryProspectus">
        <div class="col-8 tt-buy-hgt no-padding-right">
          <a [href]="item.url" target="_blank">{{item.fileName}}</a>
        </div>
        <div class="col-4 tt-buy-hgt text-right">
          <label class="label-name text-left">{{item.applyAt}}</label>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-12 mt-3" *ngIf="listRegulation?.length">
      <div class="row table-row table-heading">
        <div class="col-8 tt-buy-hgt">
          <label class="title-fee">{{'Điều lệ quỹ' | translate}}</label>
          <br />
        </div>
        <div class="col-4 col-sm-4 tt-buy-hgt"></div>
      </div>
      <div class="row row-color" *ngFor="let item of listRegulation">
        <div class="col-8 tt-buy-hgt no-padding-right">
          <a [href]="item.url" target="_blank">{{item.fileName}}</a>
        </div>
        <div class="col-4 tt-buy-hgt text-right">
          <label class="label-name text-left">{{item.applyAt}}</label>
        </div>
      </div>
    </div>

    <div class="block-nodata flex-center" *ngIf="listRegulation?.length === 0  && listProspectus?.length === 0">
      <img [src]="'icon/nodata-chart.svg' | image" alt="không dữ liệu chart" />
      <h5> {{'Không có dữ liệu' | translate}}</h5>
    </div>
  </div>
</div>
